// extracted by css-extract-rspack-plugin
export default {"root":"oOTbKNeadksu1cMW"};